import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/auth/Login";
import SignUp from "@/views/auth/SignUp";
import AdminLogin from "@/views/auth/AdminLogin";
import VerifyEmail from "@/views/auth/VerifyEmail";
import WelcomeScreen from "@/views/wellcome/WelcomeScreen";
import Dashboard from "@/views/dashboard/Dashboard";
import Property from "@/views/space/Property";
// import LandingPage from "@/views/home/LandingPage";
import ForgotPassword from "@/views/forgot_password/ForgotPassword";
import Report from "@/views/reports/reports";
import Validation from "@/views/validation/validations";
import ReportTest from "@/views/reports/reports-test";
import ReportPdf from "@/views/reports/pdfExport";
import MonthlyCustomerPayment from "@/views/payment/MonthlyCustomerPayment";
import ThankYou from "@/views/auth/ThankYou";
import PermitDeleted from "@/views/auth/PermitDeleted";
import Audit from "@/views/audit/Audit";
import PermitList from "@/views/permit/PermitList";
import OperatorUsers from "@/views/operators_users/OpearatorsUsers";
import OperatorManagement from "@/views/operator_management/OperatorManagement";
import OperatorInvitation from "@/views/operator_management/OperatorInvitation";
import Watchlist from "@/views/watchlist/Watchlist";
import ExportReports from "@/views/reports/export-reports";
import Test from "@/views/test/test";
import * as Sentry from "@sentry/vue";
import config from "../config";

Sentry.init({
  Vue: Vue,
  dsn: config.dsnSentry,
  browserTracingOptions: {
    tracingOrigins: ["localhost", /^https:\/\/commercial.pied\.cloud/],
  },
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    // name: "LandingPage",
    // component: LandingPage,
    // meta: { hideNavigation: true },
    redirect: "/login",
    meta: { progress: true },
  },
  {
    path: "/admin-login",
    name: "AdminLogin",
    component: AdminLogin,
    meta: { hideNavigation: true, requireAuth: false, progress: true },
  },
  {
    path: "/operator-sign-in",
    name: "OperatorInvitation",
    component: OperatorInvitation,
    meta: { hideNavigation: true, requireAuth: false, progress: true },
  },
  {
    path: "/export-report/:id",
    name: "ExportReports",
    component: ExportReports,
    meta: { hideNavigation: true, requireAuth: false, progress: true },
  },
  {
    path: "/thank-you",
    name: "ThankYou",
    component: ThankYou,
    meta: { hideNavigation: true },
  },
  {
    path: "/permit-deleted",
    name: "PermitDeleted",
    component: PermitDeleted,
    meta: { hideNavigation: true },
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: VerifyEmail,
    meta: { hideNavigation: true, progress: true },
  },
  {
    path: "/payment",
    name: "Payment",
    component: MonthlyCustomerPayment,
    meta: { hideNavigation: true, progress: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { hideNavigation: true, progress: true },
  },
  {
    path: "/operator-login/:uuid",
    name: "OperatorLogin",
    component: Login,
    meta: { hideNavigation: true, progress: true },
  },
  {
    path: "/signup/:uuid",
    name: "SignUp",
    component: SignUp,
    meta: { hideNavigation: true, progress: true },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { hideNavigation: true, progress: true },
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: WelcomeScreen,
    meta: { hideNavigation: true, requireAuth: true, progress: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },
  {
    path: "/property",
    name: "Property",
    component: Property,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },
  {
    path: "/report",
    name: "Report",
    component: Report,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },
  {
    path: "/validation",
    name: "Validation",
    component: Validation,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },
  {
    path: "/permit",
    name: "Permit",
    component: PermitList,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },
  {
    path: "/users",
    name: "OperatorUsers",
    component: OperatorUsers,
  },
  {
    path: "/audit",
    name: "Audit",
    component: Audit,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },
  {
    path: "/operators",
    name: "Operators",
    component: OperatorManagement,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },
  {
    path: "/watchlist",
    name: "Watchlist",
    component: Watchlist,
    meta: {
      requireAuth: true,
      progress: true,
    },
  },

  {
    path: "/report-test",
    name: "Report-test",
    component: ReportTest,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/report-pdf",
    name: "reportPdf",
    component: ReportPdf,
    meta: {
      requireAuth: true,
      hideNavigation: true,
      progress: true,
    },
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
    meta: { hideNavigation: true, progress: true },
  },
  {
    path: "*",
    redirect: "/login",
    meta: { progress: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((route) => route.meta.requireAuth)) {
    if (localStorage.getItem("commercial_token_new") != null) {
      if (localStorage.getItem("commercial_access_list") !== null) {
        const access_list = JSON.parse(
          localStorage.getItem("commercial_access_list")
        );
        if (to.path == "/permit" && access_list.permit_access == false) {
          next({ path: "/dashboard" });
        }

        if (to.path == "/report" && access_list.report_access == false) {
          next({ path: "/dashboard" });
        }

        if (
          to.path == "/validation" &&
          access_list.validation_access == false
        ) {
          next({ path: "/dashboard" });
        }

        if (to.path == "/audit" && access_list.audit_access == false) {
          next({ path: "/dashboard" });
        }
      }
      next();
    } else {
      next({ path: "/login" });
    }

    if (localStorage.getItem("admin_access") == null) {
      const admin_access = localStorage.getItem("admin_access");
      if (to.path == "/audit" && admin_access == null) {
        next({ path: "/dashboard" });
      }
      next();
    }
    // else{
    //   next({ path: "/login" });
    // }
  }
  next();
});

export default router;
